<template>
  <div class="calendar-month">
    <div class="calendar-month__title">
      {{month_name}}
      <template v-if="show_year_in_month">
        {{month_year}}
      </template>
    </div>
    <div class="calendar-month_block">
      <div class="calendar-month_grid calendar-month_week">
        <div v-for="week_day in week_days_header">
          {{week_day}}
        </div>
      </div>
      <div
        :class="`month_week-day-start-${month_weekday_start_valid}`"
        class="calendar-month_grid calendar-month_days">
        <calendar-day
          v-for="day in days"
          :day="day"
          :month_index="month_index"
          :year="month_year"
          :current_date="current_date"
          :key="`${month_year}_${month_index}_${day}`"
          :selected_dates="selected_dates"
          :disabled_dates="disabled_dates"
          :background_texts_by_date="background_texts_by_date"
          :selectable_weekend="selectable_weekend"
          @selectedDay="(date) => $emit('selectedDay', date)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CalendarDay from "./CalendarDay";
export default {
  name: "CalendarMonth",
  components: {CalendarDay},
  props: {
    month_index: {
      type: Number,
      required: true
    },
    current_date: {
      type: String,
      required: true
    },
    month_year: {
      type: Number,
      required: true
    },
    month_name: {
      type: String,
      default: ''
    },
    show_year_in_month: {
      type: Boolean,
      default: false
    },
    selected_dates: {
      type: Array,
      default: () => []
    },
    background_texts_by_date: {
      type: Object,
      default: null
    },
    disabled_dates: {
      type: Array,
      default: () => []
    },
    selectable_weekend: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    max_day_in_mouth() {
      return (new Date(this.month_year, this.month_index + 1, 0)).getDate()
    },
    days() {
      return Array.from(Array(this.max_day_in_mouth), (_, i) => i + 1)
    },
    week_days_header() {
      return [
        "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"
      ]
    },
    month_weekday_start() {// month week starts from "Sunday" default
      return (new Date(this.month_year, this.month_index, 1)).getDay()
    },
    month_weekday_start_valid() {// month week starts from "Monday"
      return !this.month_weekday_start ? 7 : this.month_weekday_start
    },
  }
}
</script>
